import React, { useContext } from 'react';
import twMerge from 'utilities/src/twMerge';
import ThemeContext from 'layout/src/components/SecondaryNavigation/_themeContext';
import Corner from './_Corner';

export default function GradientCorner() {
  const { theme } = useContext(ThemeContext);
  return (
    <>
      <Corner isDark={false} classes={twMerge({ 'opacity-0': theme === 'dark' })} />
      <Corner isDark classes={twMerge({ 'opacity-0': theme !== 'dark' })} />
    </>
  );
}
